const MOBILE_DEVICE_PATTERN =
  /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS|SM-[TX]\d{3,4}|Galaxy Tab|SamsungBrowser/i;
const DESKTOP_DEVICE_PATTERN = /Windows NT/i;

export const MAX_MOBILE_WIDTH = 1024;

export const isMobileDevice = () => {
  if (MOBILE_DEVICE_PATTERN.test(navigator.userAgent)) {
    return true;
  }

  if (DESKTOP_DEVICE_PATTERN.test(navigator.userAgent)) {
    return false;
  }

  // iPadOS는 데스크톱 UA를 보내므로 터치 지원과 화면 크기로 보완
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  return isTouchDevice && window.innerWidth <= MAX_MOBILE_WIDTH;
};
